var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M16.125 5.737a.84.84 0 0 0-.725-.579l-4.573-.415L9.02.51a.842.842 0 0 0-1.548 0L5.663 4.744l-4.573.415a.842.842 0 0 0-.478 1.473l3.456 3.031-1.019 4.49a.842.842 0 0 0 1.252.91l3.944-2.358 3.943 2.357a.842.842 0 0 0 1.253-.91l-1.02-4.489 3.457-3.03c.254-.222.347-.8.247-.895z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.07bca73c958ebc9a1e407127b2b1c8a1.svg";
export { ForwardRef as ReactComponent };